import styled from "styled-components";

import { Modal } from "react-bootstrap";

export const Container = styled(Modal.Body)`
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 10px;
  width: auto;
  height: auto;
  padding: 25px;
  overflow-x: hidden;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;



export const CloseIcon = styled.span`
  font-size: 22px;
  color: white;
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  gap: 30px;

  @media (max-width: 468px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ContentImg = styled.img`
  width: 100%;
`;
